import React, { Component, Fragment } from "react";
import NavBar from "../molecules/NavBar";
import ListaProyectos from "../atoms/proyectos/ListaProyectos";
import FotoContacto from "../atoms/FotoContacto";

import List from "@material-ui/core/List";

import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Redirect, Link } from "react-router-dom";

class PerfilUsuario extends Component {
  render() {
    const { projects, auth, profile } = this.props;
    console.log(profile);

    let nombreUsuario = profile.firstName + ' ' + profile.lastName
    let proyectosUsuario =
      projects && projects.filter(project => project.authorId === auth.uid);

    if (!auth.uid) return <Redirect to="/entrar" />;
    else if (!projects || projects === undefined || projects.length === 0)
      return (
        <Fragment>
          <NavBar />
          <div className="container ptb grey lighten-5 rounded p-5 center-align">
            <p className="blue-text">
              No tienes proyectos, por favor, añade uno para continuar.
            </p>
            <Link to="/crearproyecto" title="Nuevo Proyecto">
              <button className="btn btn-large btn-block blue accent-4">
                CREAR PROYECTO
              </button>
            </Link>
          </div>
        </Fragment>
      );
    else if (projects)
      return (
        <Fragment>
          <NavBar />
          <div className="container ptb">
            <div className="center-align ptb">
              <FotoContacto />
              <h3 className="center-align">{ nombreUsuario }</h3>
              <h5 className="center-align grey-text text-darken-3">{ profile.cargo }</h5>
            </div>
            <div className="row">
              <div className="col s12 m6">
                
                <p className="grey-text">Empresa</p>
                <p className="">{profile.empresa}</p>
                <p className="grey-text">Cargo</p>
                <p className=""> {profile.cargo} </p>
                <p className="grey-text">Departamento</p>
                <p className=""> {profile.departamento} </p>
                <p className="grey-text">Teléfono 1</p>
                <p className="">{profile.tel1}</p>
                <p className="grey-text">Teléfono 2</p>
                <p className="">{profile.tel2}</p>
                <p className="grey-text">Email</p>
                <p className="">{profile.eMail}</p>
                
              </div>
              <div className="col s12 m5 offeset-m1 center-align">
                <List>
                  <ListaProyectos proyectosUsuario={proyectosUsuario} />
                </List>
              </div>
            </div>
          </div>
        </Fragment>
      );

    return (
      <div className="container center viewportCenter">
        <div className="preloader-wrapper active">
          <div className="spinner-layer spinner-blue-only">
            <div className="circle-clipper left">
              <div className="circle" />
            </div>
            <div className="gap-patch">
              <div className="circle" />
            </div>
            <div className="circle-clipper right">
              <div className="circle" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // console.log(state);
  return {
    auth: state.firebase.auth,
    notifications: state.firestore.ordered.notifications,
    profile: state.firebase.profile,
    projects: state.firestore.ordered.projects
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(props => [
    {
      collection: "projects",
      orderBy: ["createdAt", "asc"]
    },
    { collection: "notifications", limit: 6, orderBy: ["time", "desc"] },
    { collection: "users" }
  ])
)(PerfilUsuario);
